import React, { useEffect, useState } from 'react';
import { RewardVisual } from './engine';

export function RewardBurst({ label, detail, cards = false }: { label: string; detail?: string; cards?: boolean }) {
    const [visible, setVisible] = useState(true);
    useEffect(() => {
        const timer = window.setTimeout(() => setVisible(false), 2400);
        return () => window.clearTimeout(timer);
    }, []);
    if (!visible) return null;
    return <span className="reward-burst">
        <span className="reward-halo" aria-hidden="true"/>
        {cards && <span className="reward-cards" aria-hidden="true"><i/><i/><i/></span>}
        <b>{label}</b>{detail && <small>{detail}</small>}
    </span>;
}
export function ObjectiveRewards({ events }: { events: RewardVisual[] }) {
    return <div className="objective-rewards" aria-hidden="true">{events.map(event => <div key={event.id} className={`objective-reward reward-${event.kind}`} style={{ left: `${event.x}%`, top: `${15 + event.y / 42.857 * 70}%` }}>
        <RewardBurst label={event.kind === 'quest' ? 'QUEST COMPLETE' : 'OBJECTIVE COMPLETE'} cards={event.drafts > 0} detail={[event.xp > 0 ? `+${Math.round(event.xp)} XP` : '', event.drafts > 0 ? `+${event.drafts} CARD DRAFT${event.drafts > 1 ? 'S' : ''}` : ''].filter(Boolean).join(' · ')}/>
    </div>)}</div>;
}
